import React, { useEffect, useState } from "react";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import Image from "../../../assets/image/image";
import { HistoryData } from "../../main/content/Donation/History";
import BoardCss from "./board.css";


// 임시로 기부금실적 데이터를 다운로드하고 받을 수 있게 했습니다.
const BoardDetail = () => {
  const match = useRouteMatch();
  const no = Number(match.params.no);

  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [Data, setData] = useState({
    Title: "",
    Username: "",
    Date: "",
    Filename: "",
    File: "",
    Content: ""
  });
  const handleChange = e => {
    setPassword(e.target.value);
  };
  const passwordCheck = () => {
    //서버 값 조회후 password값이랑 비교
    if (password) {
      setLoading(false);
    } else if (password === "") {
      alert("비밀번호를 입력해주세요.");
    } else {
      alert("비밀번호가 일치하지 않습니다.");
    }
  };
  const BoardList = () => {
    history.goBack();
  };
  //API 통신시 필요한 게시글 상세 번호
  // 임시 HistoryData를 이용한 기부금실적 다운로드 가능
  useEffect(() => {
    HistoryData.map(data => {
      if (data.idx === no) {
        setData({
          Title: data.title,
          Username: data.createuser,
          Date: data.createat,
          Filename: data.filename,
          File: data.file,
          Content: data.content
        });
      }
    });
    console.log(no);
  }, []);
  // 비밀번호가 걸려있다면 비밀번호 입력 화면 / 없다면 게시판 상세 화면
  return loading ? (
    <BoardCss.BoardDetailContainer>
      <div className="BoardDetailPassword">
        <img src={Image.passwordcheck} alt="passwordcheck"></img>
        <div className="BoardDetailPasswordInputContainer">
          <div className="BoardDetailPasswordInputContainerTitle">
            <img
              src="https://img.icons8.com/color/15/000000/lock--v1.png"
              alt="lock"
            ></img>
            <p>등록하신 비밀번호를 입력해주세요.</p>
          </div>
          <input id="password" type="password" onChange={handleChange}></input>
          <div>
            <button type="button" onClick={passwordCheck}>
              확인
            </button>
            <button
              type="button"
              onClick={BoardList}
              className="BoardDetailCancel"
            >
              취소
            </button>
          </div>
        </div>
      </div>
    </BoardCss.BoardDetailContainer>
    // 임시로 되어있는 HistoryData가 존재할 시 파일첨부 다운로드 및 데이터 바인딩 가능
  ) : Data.Title ? (
    <BoardCss.BoardDetailContainer>
      <div className="BoardDetail">
        <div className="BoardDetailRow">
          <div className="BoardDetailTitle">제목</div>
          <div className="BoardDetailContent">{Data.Title}</div>
        </div>
        <div className="BoardDetailRow">
          <div className="BoardDetailTitle">작성자</div>
          <div className="BoardDetailContent">{Data.Username}</div>
        </div>
        <div className="BoardDetailRow">
          <div className="BoardDetailTitle">날짜</div>
          <div className="BoardDetailContent">{Data.Date}</div>
        </div>
        <div className="BoardDetailRow">
          <div className="BoardDetailTitle">첨부파일</div>
          <div className="BoardDetailContent">
            <Link
              to={`/asset/${Data.File}`}
              target="_blank"
              download={Data.Filename}
            >
              {Data.Filename}
            </Link>
          </div>
        </div>
        <div className="BoardDetailRow">
          <div className="BoardDetailDescription">
            <p>{Data.Content}</p>
          </div>
        </div>
      </div>
      <button type="button" onClick={BoardList}>
        목록
      </button>
    </BoardCss.BoardDetailContainer>
  ) : (
    <BoardCss.BoardDetailContainer>
      <div className="BoardDetail">
        <div className="BoardDetailRow">
          <div className="BoardDetailTitle">제목</div>
          <div className="BoardDetailContent">
            2020년도 연간 기부금 모금액과 활동 실적
          </div>
        </div>
        <div className="BoardDetailRow">
          <div className="BoardDetailTitle">작성자</div>
          <div className="BoardDetailContent">관리자</div>
        </div>
        <div className="BoardDetailRow">
          <div className="BoardDetailTitle">날짜</div>
          <div className="BoardDetailContent">2021-04-14</div>
        </div>
        {/* 첨부파일이 있다면 보여주고 아니라면 삭제 */}
        {Data.File ? (
          <div className="BoardDetailRow">
            <div className="BoardDetailTitle">첨부파일</div>
            <div className="BoardDetailContent">
              연간 기부금 모금액 및 활용실적 명세서(재능).pdf
            </div>
          </div>
        ) : null}
        <div className="BoardDetailRow">
          <div className="BoardDetailDescription">
            <p>
              관련법령에 따라 2020년도 기부금 모금액 활용실적 명세서를
              첨부파일로 공개합니다.
            </p>
          </div>
        </div>
      </div>
      <button type="button" onClick={BoardList}>
        목록
      </button>
    </BoardCss.BoardDetailContainer>
  );
};

export default BoardDetail;
